export default __webpack_public_path__ + "static/video-8-34db1a09a8217c8c30bb8de094ef9387.png";